import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BreadcrumbDeleteButton,
  BreadcrumbNonDeleteButton,
} from "../../../store/actions";

const FILTER_OPTIONS = [
  { key: "nonDeleted", label: "NonDeleted" },
  { key: "deleted", label: "Deleted" },
  { key: "both", label: "Both" },
];

const DeletedOrNonDeletedFilter = () => {
  const dispatch = useDispatch();
  const { IsRadioButtonView } = useSelector(
    (state) => state.BreadcrumbReducer
  );

  const [selected, setSelected] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const hoverTimeoutRef = useRef(null);

  const handleSelect = (key) => {
    setSelected(key);
    setIsOpen(false);

    switch (key) {
      case "nonDeleted":
        dispatch(BreadcrumbNonDeleteButton(true));
        dispatch(BreadcrumbDeleteButton(false));
        break;
      case "deleted":
        dispatch(BreadcrumbNonDeleteButton(false));
        dispatch(BreadcrumbDeleteButton(true));
        break;
      case "both":
        dispatch(BreadcrumbNonDeleteButton(true));
        dispatch(BreadcrumbDeleteButton(true));
        break;
      default:
        break;
    }
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!IsRadioButtonView) return null;

  const selectedLabel = selected
    ? FILTER_OPTIONS.find((opt) => opt.key === selected)?.label
    : "Filter";

  return (
    <div
      ref={dropdownRef}
      className="position-relative d-inline-block mt-2"
      style={{ zIndex: 1050 }}
      onMouseEnter={() => {
        clearTimeout(hoverTimeoutRef.current);
        setIsOpen(true);
      }}
      onMouseLeave={() => {
        hoverTimeoutRef.current = setTimeout(() => setIsOpen(false), 150);
      }}
    >
      <button
        className="btn btn-outline-secondary btn-sm btn-rounded dropdown-toggle text-truncate"
        type="button"
        style={{
          minWidth: "120px", // Minimum width to fit "NonDeleted"
          maxWidth: "90vw",
          padding: "0.375rem 0.75rem",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "0.9rem", // Increased font size for the button heading
        }}
      >
        {selectedLabel}
      </button>

      <ul
        className={`dropdown-menu filter-dropdown-menu p-0 ${isOpen ? "show" : ""}`}
      >
        {FILTER_OPTIONS.map((option) => (
          <li key={option.key}>
            <button
              className="dropdown-item"
              onClick={() => handleSelect(option.key)}
              disabled={selected === option.key} // Disable if selected
              style={{ cursor: selected === option.key ? "not-allowed" : "pointer" }}
            >
              {option.label}
            </button>
          </li>
        ))}
      </ul>

      {/* Inline styles */}
      <style>{`
        .filter-dropdown-menu {
          min-width: 150px; /* match button min-width */
          max-width: 90vw;  /* no overflow viewport */
          position: absolute;
          top: 100%;
          left: 0;
          margin-top: 0.25rem;
          margin-left: -20px;
          border: 1px solid #dee2e6;
          border-radius: 0.25rem;
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.15);
          overflow-y: auto;
          max-height: 250px;
          white-space: nowrap;
          background-color: #fff;
          z-index: 1051;
        }

        .dropdown-item {
          padding: 0.5rem 1rem;
          font-size: 0.875rem;
          transition: background-color 0.2s ease;
        }

        .dropdown-item:hover:not(:disabled) {
          background-color: #f1f1f1;
          color: #000;
        }

        .dropdown-item:disabled {
          color: #aaa;
          background-color: #f8f9fa;
        }

        .dropdown-toggle::after {
          font-size: 0.9rem; /* Increase the size of the dropdown arrow */
        }

        @media (max-width: 768px) {
          .filter-dropdown-menu {
            right: 0;
            left: auto;
          }
        }
      `}</style>
    </div>
  );
};

export default React.memo(DeletedOrNonDeletedFilter);
